"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var formik_1 = require("formik");
var react_1 = __importDefault(require("react"));
var context_1 = require("../../../context");
var FormControl_1 = __importDefault(require("../../FormControl"));
var Input_1 = __importDefault(require("../../Input"));
var PhoneSecondaryInput = function () {
    var trans = context_1.useSemantics().trans;
    var errors = formik_1.useFormikContext().errors;
    return (react_1.default.createElement(FormControl_1.default, { errors: errors.secondary_phone_number, dusk: "phone-primary-field", label: trans('optiiva::labels.phone-number-secondary') },
        react_1.default.createElement(Input_1.default, { dusk: "phone-number-secondary", name: "secondary_phone_number", maxLength: 32 })));
};
exports.default = PhoneSecondaryInput;
//# sourceMappingURL=PhoneSecondaryInput.js.map